// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Job Ads list (Departments → Occupations → Job Ads)
   Scoped with the "ja-" prefix so nothing leaks into the rest of the app.
   Colours follow the Paper Dashboard palette used across the platform:
   primary #51cbce, success #6bd098, warning #fbc658, text #252422 / #66615b.
   ========================================================================== */

.dept-root {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 0;
}

/* ---------- Department ---------- */
.ja-dept {
    background: #fff;
    border: 1px solid #e3e3e3;
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow .15s ease, border-color .15s ease;
}

.ja-dept:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
}

.ja-dept.is-open {
    border-color: #51cbce;
    box-shadow: 0 2px 10px rgba(81, 203, 206, .15);
}

.ja-dept-header {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    background: #fff;
    border: none;
    border-left: 4px solid transparent;
    text-align: left;
    cursor: pointer;
    color: #252422;
}

.ja-dept-header:hover {
    background: #fafafa;
}

.ja-dept.is-open .ja-dept-header,
.ja-dept.is-active .ja-dept-header {
    border-left-color: #51cbce;
}

.ja-dept-icon {
    flex: 0 0 32px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(81, 203, 206, .15);
    color: #51cbce;
    font-size: 14px;
}

.ja-dept-text {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.ja-dept-name {
    font-weight: 600;
    font-size: 14px;
}

.ja-dept-meta {
    font-size: 12px;
    color: #9a9a9a;
}

.ja-chevron {
    color: #9a9a9a;
    font-size: 12px;
    transition: transform .2s ease;
}

.is-open > .ja-dept-header .ja-chevron,
.is-open > .ja-occ-header .ja-chevron {
    transform: rotate(180deg);
    color: #51cbce;
}

.ja-dept-body {
    padding: 4px 10px 10px 18px;
    border-top: 1px solid #f0f0f0;
    background: #fcfcfc;
}

/* ---------- Occupation ---------- */
.ja-occ {
    margin-top: 6px;
    border-radius: 6px;
}

.ja-occ-header {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    background: transparent;
    border: 1px solid transparent;
    border-radius: 6px;
    text-align: left;
    cursor: pointer;
    color: #66615b;
    font-size: 13.5px;
    font-weight: 600;
}

.ja-occ-header:hover {
    background: #f3f3f3;
}

.ja-occ.is-open > .ja-occ-header,
.ja-occ.is-active > .ja-occ-header {
    background: #fff;
    border-color: #e3e3e3;
    color: #252422;
}

.ja-occ-name {
    flex: 1 1;
    min-width: 0;
}

.ja-count {
    flex: 0 0 auto;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 999px;
    background: #f1f1f1;
    color: #66615b;
    white-space: nowrap;
}

.ja-count strong {
    color: #1e7e4a;
}

.ja-jobs {
    padding: 2px 0 4px 14px;
    border-left: 2px solid #eeeeee;
    margin: 4px 0 4px 12px;
}

/* ---------- Job ad ---------- */
.ja-job {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    margin-top: 6px;
    background: #fff;
    border: 1px solid #ececec;
    border-left: 3px solid transparent;
    border-radius: 6px;
    text-align: left;
    cursor: pointer;
    font-size: 13px;
    color: #252422;
    transition: background .15s ease, border-color .15s ease;
}

.ja-job:hover {
    background: #f7fdfd;
    border-color: #cfeff0;
}

.ja-job.is-selected {
    background: rgba(81, 203, 206, .12);
    border-color: #51cbce;
    border-left-color: #51cbce;
}

.ja-job.is-selected .ja-job-title {
    font-weight: 600;
}

.ja-job-dot {
    flex: 0 0 8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #c4c4c4;
}

.ja-job-title {
    flex: 1 1;
    min-width: 0;
}

/* ---------- Status pill ---------- */
.ja-status {
    flex: 0 0 auto;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 999px;
    text-transform: capitalize;
    background: #f1f1f1;
    color: #66615b;
}

.ja-status--published {
    background: #dcf5e7;
    color: #1e7e4a;
}

.ja-status--pending {
    background: #fff4d6;
    color: #8a6100;
}

.ja-status--complete {
    background: #dff3f9;
    color: #1b6f87;
}

.ja-job-dot.ja-status--published { background: #6bd098; }
.ja-job-dot.ja-status--pending { background: #fbc658; }
.ja-job-dot.ja-status--complete { background: #51bcda; }

/* ---------- Per-status counts (header, departments, occupations) ---------- */
.ja-summary {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 2px 10px;
    border-radius: 999px;
    background: #f5f5f5;
    font-size: 12px;
    font-weight: 600;
    color: #66615b;
    white-space: nowrap;
}

.ja-summary-item {
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.ja-header-summary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 14px;
}

/* ---------- Shared helpers ---------- */
.truncate-1 {
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
}

.ja-empty {
    text-align: center;
    color: #9a9a9a;
    padding: 28px 12px;
    font-size: 13px;
}

.ja-empty i {
    display: block;
    font-size: 28px;
    margin-bottom: 8px;
    color: #c4c4c4;
}

@media (max-width: 576px) {
    .ja-dept-body { padding-left: 10px; }
    .ja-jobs { margin-left: 4px; padding-left: 8px; }
}
`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/LeftCard/DepartmentDropdown.css"],"names":[],"mappings":"AAAA;;;;;+EAK+E;;AAE/E;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;AACjB;;AAEA,qCAAqC;AACrC;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,8BAA8B;AAClC;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;IACd,wDAAwD;AAC5D;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mCAAmC,mBAAmB,EAAE;AACxD,iCAAiC,mBAAmB,EAAE;AACtD,kCAAkC,mBAAmB,EAAE;;AAEvD,+EAA+E;AAC/E;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;AAEA,yCAAyC;AACzC;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB,kBAAkB,EAAE;IACpC,WAAW,gBAAgB,EAAE,iBAAiB,EAAE;AACpD","sourcesContent":["/* ==========================================================================\n   Job Ads list (Departments → Occupations → Job Ads)\n   Scoped with the \"ja-\" prefix so nothing leaks into the rest of the app.\n   Colours follow the Paper Dashboard palette used across the platform:\n   primary #51cbce, success #6bd098, warning #fbc658, text #252422 / #66615b.\n   ========================================================================== */\n\n.dept-root {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    min-height: 0;\n}\n\n/* ---------- Department ---------- */\n.ja-dept {\n    background: #fff;\n    border: 1px solid #e3e3e3;\n    border-radius: 8px;\n    overflow: hidden;\n    transition: box-shadow .15s ease, border-color .15s ease;\n}\n\n.ja-dept:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, .06);\n}\n\n.ja-dept.is-open {\n    border-color: #51cbce;\n    box-shadow: 0 2px 10px rgba(81, 203, 206, .15);\n}\n\n.ja-dept-header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px 14px;\n    background: #fff;\n    border: none;\n    border-left: 4px solid transparent;\n    text-align: left;\n    cursor: pointer;\n    color: #252422;\n}\n\n.ja-dept-header:hover {\n    background: #fafafa;\n}\n\n.ja-dept.is-open .ja-dept-header,\n.ja-dept.is-active .ja-dept-header {\n    border-left-color: #51cbce;\n}\n\n.ja-dept-icon {\n    flex: 0 0 32px;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(81, 203, 206, .15);\n    color: #51cbce;\n    font-size: 14px;\n}\n\n.ja-dept-text {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.ja-dept-name {\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.ja-dept-meta {\n    font-size: 12px;\n    color: #9a9a9a;\n}\n\n.ja-chevron {\n    color: #9a9a9a;\n    font-size: 12px;\n    transition: transform .2s ease;\n}\n\n.is-open > .ja-dept-header .ja-chevron,\n.is-open > .ja-occ-header .ja-chevron {\n    transform: rotate(180deg);\n    color: #51cbce;\n}\n\n.ja-dept-body {\n    padding: 4px 10px 10px 18px;\n    border-top: 1px solid #f0f0f0;\n    background: #fcfcfc;\n}\n\n/* ---------- Occupation ---------- */\n.ja-occ {\n    margin-top: 6px;\n    border-radius: 6px;\n}\n\n.ja-occ-header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 10px;\n    background: transparent;\n    border: 1px solid transparent;\n    border-radius: 6px;\n    text-align: left;\n    cursor: pointer;\n    color: #66615b;\n    font-size: 13.5px;\n    font-weight: 600;\n}\n\n.ja-occ-header:hover {\n    background: #f3f3f3;\n}\n\n.ja-occ.is-open > .ja-occ-header,\n.ja-occ.is-active > .ja-occ-header {\n    background: #fff;\n    border-color: #e3e3e3;\n    color: #252422;\n}\n\n.ja-occ-name {\n    flex: 1;\n    min-width: 0;\n}\n\n.ja-count {\n    flex: 0 0 auto;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 999px;\n    background: #f1f1f1;\n    color: #66615b;\n    white-space: nowrap;\n}\n\n.ja-count strong {\n    color: #1e7e4a;\n}\n\n.ja-jobs {\n    padding: 2px 0 4px 14px;\n    border-left: 2px solid #eeeeee;\n    margin: 4px 0 4px 12px;\n}\n\n/* ---------- Job ad ---------- */\n.ja-job {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 10px;\n    margin-top: 6px;\n    background: #fff;\n    border: 1px solid #ececec;\n    border-left: 3px solid transparent;\n    border-radius: 6px;\n    text-align: left;\n    cursor: pointer;\n    font-size: 13px;\n    color: #252422;\n    transition: background .15s ease, border-color .15s ease;\n}\n\n.ja-job:hover {\n    background: #f7fdfd;\n    border-color: #cfeff0;\n}\n\n.ja-job.is-selected {\n    background: rgba(81, 203, 206, .12);\n    border-color: #51cbce;\n    border-left-color: #51cbce;\n}\n\n.ja-job.is-selected .ja-job-title {\n    font-weight: 600;\n}\n\n.ja-job-dot {\n    flex: 0 0 8px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #c4c4c4;\n}\n\n.ja-job-title {\n    flex: 1;\n    min-width: 0;\n}\n\n/* ---------- Status pill ---------- */\n.ja-status {\n    flex: 0 0 auto;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 8px;\n    border-radius: 999px;\n    text-transform: capitalize;\n    background: #f1f1f1;\n    color: #66615b;\n}\n\n.ja-status--published {\n    background: #dcf5e7;\n    color: #1e7e4a;\n}\n\n.ja-status--pending {\n    background: #fff4d6;\n    color: #8a6100;\n}\n\n.ja-status--complete {\n    background: #dff3f9;\n    color: #1b6f87;\n}\n\n.ja-job-dot.ja-status--published { background: #6bd098; }\n.ja-job-dot.ja-status--pending { background: #fbc658; }\n.ja-job-dot.ja-status--complete { background: #51bcda; }\n\n/* ---------- Per-status counts (header, departments, occupations) ---------- */\n.ja-summary {\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    padding: 2px 10px;\n    border-radius: 999px;\n    background: #f5f5f5;\n    font-size: 12px;\n    font-weight: 600;\n    color: #66615b;\n    white-space: nowrap;\n}\n\n.ja-summary-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.ja-header-summary {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 4px 14px;\n}\n\n/* ---------- Shared helpers ---------- */\n.truncate-1 {\n    display: inline-block;\n    max-width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n}\n\n.ja-empty {\n    text-align: center;\n    color: #9a9a9a;\n    padding: 28px 12px;\n    font-size: 13px;\n}\n\n.ja-empty i {\n    display: block;\n    font-size: 28px;\n    margin-bottom: 8px;\n    color: #c4c4c4;\n}\n\n@media (max-width: 576px) {\n    .ja-dept-body { padding-left: 10px; }\n    .ja-jobs { margin-left: 4px; padding-left: 8px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
